import FeatureFlag from "./FeatureFlag";

const __PROD__: boolean = process.env.ENVIRONMENT === "prod";
const __BETA__: boolean = process.env.ENVIRONMENT === "dev";
const ENVIRONMENT: "prod" | "beta" = __PROD__ ? "prod" : "beta";

export { FeatureFlag, __PROD__, __BETA__, ENVIRONMENT };
